import React, { FC } from "react";

import { EntityFormHeader } from "../../../../common/entity-form";
import CompensationProcedureFormHeaderTitle from "./compensation-procedure-form-header-title";
import CompensationProcedureFormAction from "./compensation-procedure-form-actions";

type CompensationProcedureFormPageHeaderProps = {
    compensationProcedureId: string;
    mode: string;
    onBackClick: () => void;
    onDeleteClick: () => void;
    onSaveClick: () => void;
    onEditClick: () => void;
    onShowLogsClick: () => void;
};

const CompensationProcedureFormPageHeader: FC<CompensationProcedureFormPageHeaderProps> = ({
    compensationProcedureId,
    mode,
    onBackClick,
    onDeleteClick,
    onSaveClick,
    onEditClick,
    onShowLogsClick,
}) => {
    return (
        <EntityFormHeader>
            <CompensationProcedureFormHeaderTitle compensationProcedureId={compensationProcedureId} mode={mode} onBackClick={onBackClick} />

            <CompensationProcedureFormAction
                mode={mode}
                onDeleteClick={onDeleteClick}
                onSaveClick={onSaveClick}
                onEditClick={onEditClick}
                onShowLogsClick={onShowLogsClick}
            />
        </EntityFormHeader>
    );
};

export default CompensationProcedureFormPageHeader;
